// import React, { Fragment, useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";

// const DomainsList = () =>{
//     const { pubId } = useParams(); // Get publisher ID from URL
//     const navigate = useNavigate();
//     const [domainList, setDoaminList] = useState("");
//     const [loading, setLoading] = useState(true);
//     const [message, setMessage] = useState("");
//     const alldomainList = async () =>{
//       try {
//             const token = localStorage.getItem("token");
//             const alldomainListRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/getAllSites/${pubId}`, {
//                     headers : {
//                         Authorization: `Bearer ${token}`,
//                         "Content-Type": "application/json",
//                         Accept: "application/json",
//                     },
//                 }
//               );
//                 console.log(alldomainListRes);
//                 if(alldomainListRes.status === 200){
//                     setDoaminList(alldomainListRes.data.data);
//                 }else {
//                   setMessage("No domains found.");
//                 }
//         } catch (error) {
//           if (error.alldomainListRes?.status === 401) {
//             console.error("Unauthorized! Token might be expired.");
//             localStorage.removeItem("token");
//             navigate("/");
//           } else {
//             console.error("Error fetching data:", error);
//           }
//           setMessage("Error fetching domain list.");
//         } finally {
//             setLoading(false);
//           }
        
//     } 

//     useEffect(() => {
//         alldomainList();
//   }, [pubId]);

//   return (
//     <section className="mainContainer">
//       <div className="container mt-4">
//         <h2>Publisher Domains</h2>
//         {message && <div className="alert alert-info">{message}</div>}
//         <button
//           className="btn btn-success mb-3 mx-2"
//           onClick={() => navigate(`/add-domain/${pubId}`)}
//         >
//           + Add Domain
//         </button>
//         <button
//          className="btn btn-warning btn-md mx-2 mb-3"
//            onClick={() => navigate(`/ad-list/${pubId}`)}>
//            Manage Ad Units
//         </button>
//         <button
//          className="btn btn-primary btn-md mx-2 mb-3"
//            onClick={() => navigate(`/update-other-setting/${pubId}`)}>
//            Update Other Settings
//         </button>
//       <table className="table table-striped table-hover table-bordered">
//                 <thead>
//             <tr>
//               <th scope="col">S.N </th>
//               <th scope="col">Domain Name</th>
//               <th scope="col">Publisher Name</th>
//               <th scope="col"></th>
//             </tr>
//           </thead>
//           <tbody>
//             {
//               domainList?.length > 0 ? (
//                   domainList.map((domainList, domainListInd) =>(
//                   <tr key={domainListInd}>
//                     <td>{domainListInd + 1}</td>
//                     <td>{domainList.domain}</td>
//                     <td>{domainList.name}</td>
//                     <td>
//                     <button
//                       className="btn btn-primary btn-sm"
//                       onClick={() => navigate(`/edit-domain/${domainList.account_id}/${domainList.id}`)}
//                       >
//                       Edit domain
//                     </button>
//                     {/* <button
//                       className="btn btn-success btn-md mx-2"
//                       onClick={() => navigate(`/create-ad/${domainList.account_id}/${domainList.id}`)}
//                     >
//                       Creat Ads
//                     </button> */}
//                     </td>
//                   </tr>
//                 ))
//               ) : 
//               <tr>
//                 <td colSpan="12" className="text-center">No data available</td>
//               </tr>
//             }
//           </tbody>
//       </table>
//       </div>
//     </section>
//   )
// }

// export default DomainsList;

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "./domainList.css";

const DomainsList = () => {
  const { pubId } = useParams();
  const navigate = useNavigate();

  const [domainList, setDomainList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  const allDomainList = async () => {
    try {
      setLoading(true);
      setMessage("");

      const token = localStorage.getItem("token");

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/getAllSites/${pubId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      if (response.status === 200) {
        setDomainList(response.data.data || []);
      } else {
        setMessage("No domains found.");
      }
    } catch (error) {
      if (error.response?.status === 401) {
        console.error("Unauthorized! Token might be expired.");

        localStorage.removeItem("token");
        localStorage.removeItem("account_id");
        localStorage.removeItem("userRole");

        navigate("/");
      } else {
        console.error("Error fetching data:", error);
        setMessage("Error fetching domain list.");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    allDomainList();
  }, [pubId]);

  return (
    <section className="domain-page">
      <div className="domain-container">

        {/* =========================
            PAGE HEADER
        ========================== */}
        <div className="domain-page-header">
          <div>
            <h1 className="domain-page-title">
              Publisher Domains
            </h1>

            <p className="domain-page-subtitle">
              Manage publisher domains and their associated ad units.
            </p>
          </div>

          <div className="domain-actions">
            <button
              type="button"
              className="domain-btn domain-btn-success"
              onClick={() => navigate(`/add-domain/${pubId}`)}
            >
              <span>+</span>
              Add Domain
            </button>

            <button
              type="button"
              className="domain-btn domain-btn-warning"
              onClick={() => navigate(`/ad-list/${pubId}`)}
            >
              Manage Ad Units
            </button>

            <button
              type="button"
              className="domain-btn domain-btn-primary"
              onClick={() =>
                navigate(`/update-other-setting/${pubId}`)
              }
            >
              Update Other Settings
            </button>
          </div>
        </div>

        {/* =========================
            MESSAGE
        ========================== */}
        {message && (
          <div className="domain-alert">
            {message}
          </div>
        )}

        {/* =========================
            TABLE CARD
        ========================== */}
        <div className="domain-table-card">

          <div className="domain-table-header">
            <div>
              <h3>Domain List</h3>
              <span>
                {domainList.length}{" "}
                {domainList.length === 1 ? "domain" : "domains"}
              </span>
            </div>
          </div>

          <div className="domain-table-wrapper">
            <table className="domain-table">
              <thead>
                <tr>
                  <th className="sn-column">S.N</th>
                  <th>Domain Name</th>
                  <th>Publisher Name</th>
                  <th className="action-column">Actions</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="4" className="domain-loading">
                      <div className="domain-spinner"></div>
                      Loading domains...
                    </td>
                  </tr>
                ) : domainList.length > 0 ? (
                  domainList.map((domain, index) => (
                    <tr key={domain.id || index}>
                      <td className="sn-column">
                        {index + 1}
                      </td>

                      <td className="domain-name-cell">
                        {domain.domain}
                      </td>

                      <td>
                        {domain.name}
                      </td>

                      <td className="action-column">
                        <button
                          type="button"
                          className="domain-edit-btn"
                          onClick={() =>
                            navigate(
                              `/edit-domain/${domain.account_id}/${domain.id}`
                            )
                          }
                        >
                          Edit Domain
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="4"
                      className="domain-empty"
                    >
                      <div className="empty-icon">
                        ◎
                      </div>

                      <strong>No domains found</strong>

                      <span>
                        This publisher doesn't have any domains yet.
                      </span>

                      <button
                        type="button"
                        className="domain-btn domain-btn-success"
                        onClick={() =>
                          navigate(`/add-domain/${pubId}`)
                        }
                      style={{width:"max-content"}} >
                        + Add Domain
                      </button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </section>
  );
};

export default DomainsList;